export const ANORDNUNG_ORDER = ["vorderseite", "sockel", "rueckseite"];
export const POSITION_ORDER = [
	"",
	"links", "mitte", "rechts", "oben", "unten",
	"oben-links", "oben-mitte", "oben-rechts",
	"mitte-links", "mitte-mitte", "mitte-rechts",
	"unten-links", "unten-mitte", "unten-rechts"
];

export const ANORDNUNG_LABELS = {
	vorderseite: "Vorderseite",
	sockel: "Postament",
	rueckseite: "Rückseite"
};

export const POSITION_LABELS = {
	"": "ganze Fläche",
	links: "links",
	mitte: "mitte",
	rechts: "rechts",
	oben: "oben",
	unten: "unten",
	"oben-links": "oben-links",
	"oben-mitte": "oben-mitte",
	"oben-rechts": "oben-rechts",
	"mitte-links": "mitte-links",
	"mitte-mitte": "mitte-mitte",
	"mitte-rechts": "mitte-rechts",
	"unten-links": "unten-links",
	"unten-mitte": "unten-mitte",
	"unten-rechts": "unten-rechts"
};

export function createInscriptionId() {
	if (typeof crypto !== "undefined" && crypto.randomUUID) {
		return crypto.randomUUID();
	}
	return "inschrift-" + Date.now() + "-" + Math.random().toString(16).slice(2);
}

export function emptyInscription(anordnung = "vorderseite") {
	return {
		id: createInscriptionId(),
		anordnung: anordnung,
		position: "",
		personId: "",
		text: [""],
		uebersetzung_1: [""],
		uebersetzung_0: [""]
	};
}

function hasLocationContent(location) {
	return location && Array.isArray(location.text) && location.text.some(line => line && String(line).trim() !== "");
}

function copyLines(lines) {
	return Array.isArray(lines) ? lines.map(line => line == null ? "" : line) : [];
}

export function fromLegacyInscription(legacy) {
	if (!legacy) {
		return [];
	}
	const blocks = [];
	const locations = [
		["vorderseite", legacy.vorderseite],
		["sockel", legacy.sockel],
		["rueckseite", legacy.rueckseite]
	];
	locations.forEach(([anordnung, location]) => {
		if (hasLocationContent(location)) {
			const block = emptyInscription(anordnung);
			block.text = copyLines(location.text);
			block.uebersetzung_1 = copyLines(location.uebersetzung_1);
			block.uebersetzung_0 = copyLines(location.uebersetzung_0);
			alignInscriptionLines(block);
			blocks.push(block);
		}
	});
	return blocks;
}

export function alignInscriptionLines(block) {
	if (!block.text) {
		block.text = [];
	}
	if (!block.uebersetzung_1) {
		block.uebersetzung_1 = [];
	}
	if (!block.uebersetzung_0) {
		block.uebersetzung_0 = [];
	}
	const size = Math.max(block.text.length, block.uebersetzung_1.length, block.uebersetzung_0.length, 1);
	while (block.text.length < size) {
		block.text.push("");
	}
	while (block.uebersetzung_1.length < size) {
		block.uebersetzung_1.push("");
	}
	while (block.uebersetzung_0.length < size) {
		block.uebersetzung_0.push("");
	}
	return block;
}

export function ensureInschriften(tombstone) {
	if (!tombstone) {
		return tombstone;
	}
	if (!Array.isArray(tombstone.inschriften) || tombstone.inschriften.length === 0) {
		tombstone.inschriften = fromLegacyInscription(tombstone.inschrift_hebraeisch);
	}
	tombstone.inschriften.forEach(block => {
		if (!block.id) {
			block.id = createInscriptionId();
		}
		if (!block.anordnung) {
			block.anordnung = "vorderseite";
		}
		if (block.position == null) {
			block.position = "";
		}
		if (block.personId == null) {
			block.personId = "";
		}
		alignInscriptionLines(block);
	});
	return tombstone;
}

export function sortInschriften(blocks) {
	const list = Array.isArray(blocks) ? [...blocks] : [];
	return list.sort((a, b) => {
		const anordnungDiff = ANORDNUNG_ORDER.indexOf(a.anordnung) - ANORDNUNG_ORDER.indexOf(b.anordnung);
		if (anordnungDiff !== 0) {
			return anordnungDiff;
		}
		return POSITION_ORDER.indexOf(a.position || "") - POSITION_ORDER.indexOf(b.position || "");
	});
}

export function inscriptionHeading(block) {
	const anordnung = ANORDNUNG_LABELS[block.anordnung] || "Vorderseite";
	if (block.position) {
		return anordnung + ", " + (POSITION_LABELS[block.position] || block.position);
	}
	return anordnung;
}

export function inscriptionOptionLabel(block) {
	return inscriptionHeading(block);
}

export function inscriptionsForPerson(blocks, personId) {
	if (!personId || !Array.isArray(blocks)) {
		return [];
	}
	return blocks.filter(block => block.personId === personId);
}
